import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AvlShipmentStop } from '@features/live-tracking/models/avl-shipment-stop.model';

@Component({
  selector: 'app-shipment-stop-marker',
  template: `
    <app-marker [size]="size" style="transform: translate(-50%, -50%)"
                (click)="togglePopup.emit(position?.positionId)">
      <mat-icon [ngClass]="'text-error'">local_parking</mat-icon>
    </app-marker>

    <div class="card--shifted" *ngIf="activePopupId === position.positionId">
      <mat-card class="p-3" style="padding: 0.75rem !important;">
        <app-row>
          <app-col class="ml-auto" cols="auto">
            <button
              mat-icon-button
              type="button"
              style="margin: -.75rem -.75rem 0 0;"
              (click)="togglePopup.emit(null)"><mat-icon>close</mat-icon></button>
          </app-col>
        </app-row>

        <app-row style="margin-top: -1rem;">
          <app-col>
            <div class="pb-2"><b>Stop Duration</b>: {{position.duration}}</div>
            <div class="py-2"><b>Start</b>: {{position.startTime | date:'short'}}</div>
            <div class="py-2"><b>End</b>: {{position.endTime | date:'short'}}</div>
          </app-col>
        </app-row>
      </mat-card>
    </div>
  `,
  styles: [
    `
      .card--shifted {
        transform: translate(-50%, -125%);
        padding-bottom: 1rem;
        font-size: 1rem;
        min-width: 240px;
      }
    `
  ]
})
export class ShipmentStopMarkerComponent {
  @Input() size: 'xs'|'sm'|'md'|'lg';
  @Input() position: AvlShipmentStop;
  @Input() activePopupId: number;
  @Output() togglePopup = new EventEmitter();

  markerSize: 'xs'|'sm'|'md'|'lg' = 'md';
}
